import React from 'react';
import { Body, Box, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import IntroCard from '../common/IntroCard';

const MHero = () => (
  <Box
    position="relative"
    maxW={{ base: 'xl', desktop: '8xl' }}
    w="100%"
    d="block"
    mx="auto"
    py="100px"
  >
    <Box mr="auto" borderRadius={10} overflow="hidden" maxW="840px">
      <StaticImage
        src="../../../assets/images/partners_manufactors_hero.jpg"
        alt=""
      />
    </Box>
    <IntroCard
      color="#d02930"
      logo={
        <Box maxH={45}>
          <StaticImage
            objectFit="contain"
            src="../../../assets/images/gaf-beacon.png"
            alt="GAF-Beacon"
          />
        </Box>
      }
      description="HOVER has a long standing partnership with GAF to deliver solutions to GAF Certified Contractors. HOVER's partnership with Beacon Roofing Supply delivers a streamlined sales and production process to home improvement professionals."
      right="212px"
      top="140px"
      pl="100px"
    />
    <IntroCard
      color="#3a7c4c"
      logo={
        <Box maxH={45}>
          <StaticImage
            objectFit="contain"
            src="../../../assets/images/james_hardie_logo.png"
            alt="James Hardie"
          />
        </Box>
      }
      description="James Hardie is a trusted leader in fiber cement siding and backer board. In partnership with HOVER, James Hardie offers a trusted source of materials and streamlined workflows for home improvement professionals."
      top="452px"
      right="132px"
      pl="100px"
    />
    <IntroCard
      color="#247ddc"
      description="Win rates increase when a completed 3D model is used during a sell. Visualize your products in 3D with HOVER."
      bottom="16px"
      left="64px"
    >
      <Box d="block" maxW={150} mx="auto" textAlign="center">
        <Heading size={500} sx={{ mb: 0 }}>
          2.6%
        </Heading>
        <Body fontWeight={300}>win rate increase</Body>
      </Box>
    </IntroCard>
  </Box>
);

export default MHero;
